import { Component } from '@angular/core';
import { FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from 'src/app/services/auth/auth.service';

function passwordMatchValidator(group: AbstractControl) {
  const p1 = group.get('password')?.value;
  const p2 = group.get('password2')?.value;
  return p1 && p2 && p1 !== p2 ? { passwordMismatch: true } : null;
}

@Component({
  selector: 'app-register-dialog',
  templateUrl: './register-dialog.component.html',
  styleUrls: ['./register-dialog.component.scss'],
})
export class RegisterDialogComponent {
  loading = false;
  apiError: string | null = null;

  successState = false;
  successMessage = ''; // ✅ ahora se setea desde backend

  identifyForm = this.fb.group({
    customerNumber: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
  });

  // (si no lo usás todavía, lo podés borrar)
  confirmForm = this.fb.group(
    {
      code: ['', [Validators.required, Validators.minLength(6)]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      password2: ['', Validators.required],
    },
    { validators: [passwordMatchValidator] },
  );

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<RegisterDialogComponent>,
    private authApi: AuthService,
    private snackBar: MatSnackBar,
  ) {}

  cancel() {
    // cerrar normal (cancelar)
    this.dialogRef.close(false);
  }

  closeSuccess() {
    // ✅ cerrar indicando éxito
    this.dialogRef.close(true);
  }

  requestCode() {
    this.apiError = null;

    this.identifyForm.markAllAsTouched();
    if (this.identifyForm.invalid) return;

    const customerNumber = this.identifyForm.value.customerNumber!.trim();
    const email = this.identifyForm.value.email!.trim();

    this.loading = true;

    this.authApi.requestRegisterCode({ customerNumber, email }).subscribe({
      next: (raw) => {
        const parsed = this.parseApi(raw);

        if (parsed.success) {
          // ✅ mostrar success dentro del modal
          this.successState = true;

          // ✅ usar el msg del backend (o uno default)
          this.successMessage = parsed.msg?.trim()
            ? parsed.msg.trim()
            : 'La operación se realizó correctamente.';

          return;
        }

        // ❌ error → toast + cerrar
        this.showToast(parsed.msg || 'Ocurrió un error.');
        this.dialogRef.close(false);
      },
      error: () => {
        this.showToast('Error al solicitar el código.');
        this.dialogRef.close(false);
      },
      complete: () => {
        this.loading = false;
      },
    });
  }

  private showToast(message: string) {
    this.snackBar.open(message, 'Cerrar', {
      duration: 3500,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }

  private parseApi(raw: any): { success: boolean; msg: string } {
    let obj: any = null;

    if (typeof raw === 'string') {
      try {
        obj = JSON.parse(raw);
      } catch {
        return { success: false, msg: raw };
      }
    } else {
      obj = raw;
    }

    const item = obj?.response?.[0];

    return {
      success: !!item?.success,
      msg: (item?.msg ?? '').toString(),
    };
  }
}
